import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useEffect, useState } from "react";
import services from "utils/services";
import { Link } from "react-router-dom";
import { DocumentIcon, PlusIcon } from "@heroicons/react/24/solid";
import dayjs from "dayjs";
import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import ModalCongesRecup from "components/ModalCongesRecup";
import ModalCongesRecupMulti from 'components/ModalCongesRecupMulti';
import Checkbox from 'shared/Checkbox/Checkbox';
import ModalUploadDocument from 'components/ModalUploadDocument';
import toast from 'react-hot-toast';
import NotifyPlanningSaved from 'components/NotifyPlanningSaved';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';

const UserList = () => {
	const [userList, setUserList] = useState<any>([]);
	const [showModalCongesRecup, setShowModalCongesRecup] = useState(false);
	const [showModalCongesRecupMulti, setShowModalCongesRecupMulti] =
		useState(false);
	const [employee, setEmployee] = useState<any>(null);
	const [allSelected, setAllSelected] = useState(false);
	const [showModalUploadDocument, setShowModalUploadDocument] = useState(false);

	useEffect(() => {
		getUsers();
	}, []);

	const getUsers = () => {
		services.getUsers(
			{},
			(success) => {
				setUserList(success.users);
			},
			(error) => console.error(error),
		);
	};
	const uploadFiles = (year: number, month: number | null, files: any) => {
		console.log({ files });
		// services.uploadDocuments(
		// 	{ files },
		// 	(success) => {},
		// 	(error) => console.error(error)
		// );
		setShowModalUploadDocument(false);
	};

	const renderUser = (user: any, index: number) => {
		const {
			matricule,
			firstName,
			lastName,
			username,
			entryDate,
			pole,
			enabled,
			exitDate,
			soldeConges,
			soldeRecup,
		} = user;
		const opacity = enabled ? '1' : '0.5';

		const firstEnabled = index > 0 && !enabled && userList[index - 1].enabled;

		return (
			<div key={index}>
				<hr className='mt-3 border-slate-200 dark:border-slate-700 '></hr>
				{firstEnabled && (
					<>
						<div className='my-5 font-medium'>Inactifs</div>
						<hr className='mt-3 border-slate-200 dark:border-slate-700 '></hr>
					</>
				)}
				<div
					className={`relative flex flex-row items-center pt-3 sm:pt-3 last:pb-0 first:pt-0 `}
				>
					<span className='w-[5%] font-medium'>
						{enabled ? (
							<Checkbox
								name=''
								sizeClassName='h-4 w-4'
								onChange={(checked) => {
									user.selected = checked;
									userList[index] = user;
									setUserList([...userList]);
								}}
								checked={user.selected}
							/>
						) : null}
					</span>
					<div className={`w-[5%] opacity-[${opacity}]`}>{matricule}</div>
					<div className={`w-[20%] opacity-[${opacity}]`}>
						{firstName} {lastName}
						<br />
						<span className='italic'>{username}</span>
					</div>
					{/* <span className="w-[25%]">{email}</span> */}
					{/* <span className={`w-[20%] opacity-[${opacity}]`}>{role}</span> */}
					<span className={`w-[20%] opacity-[${opacity}] text-md`}>{pole}</span>
					<span className={`w-[15%] opacity-[${opacity}]`}>
						{dayjs(entryDate).format('DD/MM/YYYY')}
						{exitDate ? ' - ' + dayjs(exitDate).format('DD/MM/YYYY') : ''}
					</span>
					<span className={`w-[25%] opacity-[${opacity}]`}>
						<span
							className={soldeConges < 0 ? 'text-danger font-semibold' : ''}
						>
							Congés : {soldeConges}
						</span>{' '}
						/{' '}
						<span
							className={
								soldeRecup < 0 || soldeRecup >= 5
									? 'text-danger font-semibold'
									: ''
							}
						>
							Récup : {soldeRecup}
						</span>
					</span>
					<div className='w-[10%] flex justify-end'>
						<Link
							className='w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full flex items-center justify-center text-right'
							to={'/employe/' + user._id}
						>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								fill='none'
								viewBox='0 0 24 24'
								strokeWidth='1.5'
								stroke='currentColor'
								className='w-6 h-6'
							>
								<path
									strokeLinecap='round'
									strokeLinejoin='round'
									d='M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10'
								/>
							</svg>
						</Link>
						<Link
							to={''}
							className='w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full flex items-center justify-center text-right'
							onClick={() => toogleModal(user)}
						>
							<ClipboardDocumentCheckIcon className='w-6 h-6' />
						</Link>
					</div>
				</div>
			</div>
		);
	};

	const toogleModal = (employee: any) => {
		if (!showModalCongesRecup && employee) {
			setShowModalCongesRecup(true);
			setEmployee(employee);
		} else {
			setShowModalCongesRecup(false);
			setEmployee(null);
		}
	};

	return (
		<div>
			{/* <CommonLayout> */}
			<div className='space-y-3 sm:space-y-5'>{/* HEADING */}</div>
			<div className='m-5 pt-2 text-right'>
				<ButtonSecondary href='/employe' className='bg-slate-200'>
					<PlusIcon className='w-5 h-5 mr-2 -ml-1' aria-hidden='true' />
					Ajouter
				</ButtonSecondary>
				{userList.some((user: any) => user.selected) && (
					<>
						<ButtonSecondary
							className='bg-slate-200'
							onClick={() => setShowModalUploadDocument(true)}
						>
							<DocumentIcon className='w-5 h-5 mr-2 -ml-1' aria-hidden='true' />
							Upload documents
						</ButtonSecondary>
						<ButtonSecondary
							className='bg-slate-200'
							onClick={() => setShowModalCongesRecupMulti(true)}
						>
							<ClipboardDocumentListIcon
								className='w-5 h-5 mr-2 -ml-1'
								aria-hidden='true'
							/>
							Congés / Récup.
						</ButtonSecondary>
					</>
				)}
			</div>

			<div className='flex flex-row'>
				<span className='w-[5%] font-medium'>
					<Checkbox
						name=''
						sizeClassName='h-4 w-4'
						onChange={(checked) => {
							userList.forEach((user: any) => (user.selected = checked));
							setUserList([...userList]);
							setAllSelected(checked);
						}}
						checked={allSelected}
					/>
				</span>
				<span className='w-[5%] font-medium'></span>
				<span className='w-[20%] font-medium'>Nom & Prénom</span>
				{/* <span className="w-[25%] font-medium">Email</span> */}
				<span className='w-[20%] font-medium'>Pole</span>
				<span className='w-[15%] font-medium'>Date d'entrée</span>
				<span className='w-[25%] font-medium'>Congés / Récup</span>
				<span className='w-[10%] font-medium'></span>
			</div>
			{/* </CommonLayout> */}
			{userList.map((user: any, index: number) => renderUser(user, index))}
			{showModalCongesRecup && (
				<ModalCongesRecup
					showForm={true}
					employee={employee}
					show={showModalCongesRecup}
					onCloseModal={() => toogleModal(null)}
				/>
			)}
			{showModalCongesRecupMulti && (
				<ModalCongesRecupMulti
					show={showModalCongesRecupMulti}
					employees={userList.filter((user: any) => user.selected)}
					onCloseModal={() => setShowModalCongesRecupMulti(false)}
					onSaved={() => {
						setShowModalCongesRecupMulti(false);
						getUsers();
						toast.custom(
							(t) => (
								<NotifyPlanningSaved
									message='Sauvegarde effectuée!'
									show={t.visible}
								/>
							),
							{
								position: 'top-center',
								id: 'nc-planning-saved',
								duration: 3000,
							},
						);
					}}
				/>
			)}
			{showModalUploadDocument && (
				<ModalUploadDocument
					employees={userList.filter((user: any) => user.selected)}
					show={showModalUploadDocument}
					onCloseModal={() => setShowModalUploadDocument(false)}
					onConfirm={() => {
						setShowModalUploadDocument(false);

						toast.custom(
							(t) => (
								<NotifyPlanningSaved
									message='Sauvegarde effectuée!'
									show={t.visible}
								/>
							),
							{
								position: 'top-center',
								id: 'nc-planning-saved',
								duration: 3000,
							},
						);
					}}
				/>
			)}
		</div>
	);
};

export default UserList;
